import React, { useCallback, useRef } from "react";
import { Platform } from "react-native";

export function useColumnResize(
  setColWidths: React.Dispatch<React.SetStateAction<Record<string, number>>>
) {
  const resizingRef = useRef<{ key: string; startX: number; startWidth: number } | null>(null);

  return useCallback((e: any, key: string, currentWidth: number) => {
    if (Platform.OS !== "web") return;
    e.preventDefault();
    e.stopPropagation();
    const startX = e.clientX ?? (e.nativeEvent && e.nativeEvent.clientX) ?? 0;
    const startW = currentWidth || 40;
    resizingRef.current = { key, startX, startWidth: startW };
    
    let frameId: number | null = null;
    
    const onMove = (ev: MouseEvent) => {
      if (!resizingRef.current) return;
      if (frameId !== null) cancelAnimationFrame(frameId);
      
      frameId = requestAnimationFrame(() => {
        if (!resizingRef.current) return;
        const currentX = ev.clientX ?? (ev as any).touches?.[0]?.clientX ?? 0;
        const newWidth = Math.max(40, resizingRef.current.startWidth + (currentX - resizingRef.current.startX));
        if (!isNaN(newWidth)) {
          setColWidths((prev) => ({ ...prev, [resizingRef.current!.key]: newWidth }));
        }
      });
    };
    
    const onUp = () => {
      if (frameId !== null) cancelAnimationFrame(frameId);
      resizingRef.current = null;
      (document as any).removeEventListener("mousemove", onMove);
      (document as any).removeEventListener("mouseup", onUp);
    };
    
    (document as any).addEventListener("mousemove", onMove);
    (document as any).addEventListener("mouseup", onUp);
  }, [setColWidths]);
}
